const findItemWithLink = (items) => {
    // if the current format has a google preview link - we preference this
    const itemForMatchingIsbn = items.find(item => {
        const { currentIsbn, formatIsbn } = item.dataset;
        return currentIsbn === formatIsbn && item.querySelector("a");
    });

    if(itemForMatchingIsbn) {
        return itemForMatchingIsbn;
    }
    // other wise we find the first format with a google link
    return items.find((item) => {
        return item.querySelector("a");
    });
};

const displayGooglePreview = (links) => {
    const items = Array.from(links);

    const firstItemWithLink = findItemWithLink(items);

    // remove all the other list items we don't want
    const others = items.filter(item => item !== firstItemWithLink);
    others.forEach(item => item.remove());

    // if there are no google link stop
    if(!firstItemWithLink) {
        return;
    }

    const link = firstItemWithLink.querySelector("a");
    link.setAttribute('target', '_blank');
    link.innerHTML = universityPressThemeSettings.show_google_preview_label;
    firstItemWithLink.style.opacity = '1';
};

window.addEventListener("load", () => {
    // adding a time out to give the google call time to execute
    setTimeout(() => {
        const googleLinks = document.querySelectorAll(".sp__google-link");
        if(!googleLinks) {
            return;
        }
        displayGooglePreview(googleLinks);
    }, 1000);
});